import React, { useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import './FixarDezenas.css';
import { SelectionContext } from '../context/SelectionContext';

const FixarDezenas = () => {
  const [selected, setSelected] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { updateSelections } = useContext(SelectionContext);

  const handleSelect = (choice) => {
    setSelected(choice);
    const rota = location.pathname.split('/')[1];
    updateSelections(rota, choice, []);
    navigate(`/${rota}/numeros/${choice.toLowerCase()}`);
  };

  return (
    <div className="fixar-dezenas">
      <h1>Fixar Dezenas</h1>
      <p>Escolha um tipo de dezenas:</p>
      <div className="d-grid gap-2 col-4 mx-auto">
        <Button variant="success" onClick={() => handleSelect('Par')}>Par</Button>
        <Button variant="success" onClick={() => handleSelect('Impar')}>Ímpar</Button>
      </div>
      {selected && <p className="selection-result">Você selecionou: {selected}</p>}
    </div>
  );
};

export default FixarDezenas;
